import styled from 'styled-components';
import { StyledBody } from '../../ChallengeDetailsV2/StartChallengePopUp/styles';
import { Modal } from 'react-bootstrap';



export const ModalBody = styled(StyledBody)`
  width: 100%;
  height: auto;
  border-radius: 12px;
  padding: ${({padding}) => padding ? padding: '0'};
`;

export const CalendarHeader = styled.div`
  width: 100%;
  height: ${({height}) => height ? height : '50px'};
  display: flex;
  border-radius: 6px 6px 0 0;
  justify-content: ${({justify}) => justify ? 'flex-start' : 'space-between'};
  padding: ${({padding}) => padding ? padding : '24px'};
  background: ${({background}) => background ? background : ''};
  align-items:center;
  .title {
    font-family: Lato;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color:#FFF;
    display: flex;
    justify-content: center;
  }

  .newTitle {
    font-family: "Lato";
    font-size: 18px;
    line-height: 24px;
    color:#184A61;
    display: flex;
    font-weight: 700;
    justify-content: center;
  }
  .dropdown-wrapper{
    display: flex;
    align-itemce:center;
    margin-right:40px;
    .label{
      color: rgba(0, 92, 135, 0.60);
      text-align: center;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      display:flex;
      align-items:center;
      margin-right:8px;
    }
    .filter-dropdown{
      width:140px;
    }
  }
  .closeButton{
    width:24px;
    height:24px;
    cursor:pointer;
    >img{
      height:100%;
      width:100%;
    }
  }
 
`


export const StyledModal = styled(Modal)`
@media (min-width: 576px){
  .modal-dialog {
    max-width:100% !important;
  }}
  .modal-dialog {
    transform: ${({transform}) => transform ? 'translate(0, 15vh) translate(0, -15%) !important' : 'translate(0, 50vh) translate(0, -50%) !important'};
    margin: ${({change}) => change ? '150px auto' : '0 auto'};
    // box-shadow: 0 5px 15px rgba(0,0,0,.5);
    @media (min-width: 576px){
      .modal-dialog {
        max-width:100% !important;
      }}
    .modal-content{
      border:none;
      box-shadow: 0 5px 15px rgba(0,0,0,.5);
      width: ${({width}) => width ? width : ''};
      padding: ${({paddingV}) => paddingV ? paddingV : ''};
    }
    @media (max-height: 460px) {
      transform: none !important;
      margin: 30px auto;
    }
    width: ${({width}) => width ? width : '490px'};
    height: ${({change, height}) => height? height :change ? '573px' : '473px'};
    @media (max-width: 500px){
      width: 95%;
      height: auto;
    }
  }

  .modal-body{
    padding: ${({padding}) => padding ? padding : '25px 0 25px 0'};

    ::-webkit-scrollbar {
       width: 10px;
     }

::-webkit-scrollbar {
   width: 5px;
   height: 5px;
 }
  ::-webkit-scrollbar-thumb {
   background: #BDBDBD;
   cursor: pointer;
   border-radius: 2.5px;
 }

::-webkit-scrollbar-track {
  background: #FEFEFE; 
  border-radius: 6px;
}
  }
  
  .modal-container {
   width: 100%;
   display: block;
   border: none;
   > div: nth-child(1) {
    width: 100%;
    height: 0px;
    display: flex;
    justify-content: flex-end;
    >img{
      width: 24px;
      height: 24px;
      cursor: pointer;
      margin: 15px 15px 0 0;
    }
   }
   > div: nth-child(2) {
    width: 100%;
    display:flex;
    justify-content: center;
    font-family: Lato;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    color:#0D4270;
    text-decoration: underline;
    margin-top: 35px;
   }
  }
  .teamWrapper{
    display:flex;
    width:100%;
    flex-wrap:wrap;
    padding: 16px 24px;
    height: ${({heightV}) => heightV ? heightV : ''};
    overflow-y: ${({scroll}) => scroll ? 'scroll' : ''}  ;

    .teamNameDiv{
      width:100%;
      .count{
        font-family: Lato;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0%;
        text-align: right;
        vertical-align: middle;
        width:100%;
        display:flex;
        margin-bottom:12px;
        color:#BDBDBD;
        justify-content:flex-end;
        }
    }
  }
`;


export const ParticipantsList = styled.div`
  width: 100%;
  height: ${({listHeight}) => listHeight ? listHeight : 'auto'};
  max-height: 530px;
  background-color: white;
  border-radius: 6px;
  margin: 0 auto;
  padding: ${({padding}) => padding ? "20px": '1px'};
  text-align: ${({padding}) => padding && 'center'};
  overflow-x: hidden;
  overflow-y: auto;
  overflow: -moz-scrollbars-none;
  border: ${({border}) => border ? "": '1px solid #005C8799;'};
  ${'' /* border: 1px solid #005C8799; */}
  ::-webkit-scrollbar {
   width: 5px;
   height: 5px;
 }
  ::-webkit-scrollbar-thumb {
   background: #c7c8c7;
   cursor: pointer;
   border-radius: 2.5px;
 }
  ::-webkit-scrollbar-track {
   background: #fff;
   border-radius: 2.5px;
 } 
  @media(max-width: 500px){
    width: 100%;
  }
`;

export const Participant = styled.div`
  width: 100%;
  height: ${({height}) => height ? height : '60px'};
  display: flex;
  margin:12px 0;
  align-items: center;
  ${'' /* padding: 20px 0; */}
  padding: ${({isPadding}) => isPadding ? isPadding : '20px 0'};
  border-top: ${({border}) => border ? "1px solid #005C8799": ''};
  .profile{
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .nameAndWellnessInterest{
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-family:Lato;

    .name{
      color: #184A61;
      opacity:  ${({isAlreadyAdded}) => isAlreadyAdded ? isAlreadyAdded : '100%'};
    }
  }
  .checkbox{
    display:flex;
    margin: auto;
    margin-right: 25px;
  }
`;

export const ImageContainer = styled.div`
  min-width: ${({ active, width }) => width ? width : active ? '92px' : '52px'};
  height: ${({ active, width }) => width ? width : active ? '92px' : '52px'};;
  border-radius: ${({ active ,isRadius}) => active ? '50%': isRadius ? isRadius : '6px'};
  background-color: #e8e7e7;
  overflow: hidden;
  border: 1px solid #DCDCDC;
  float: left;
  margin: ${({ isMargin }) => isMargin ? isMargin : '0 15px 0 15px'};
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  opacity:  ${({isAlreadyAdded}) => isAlreadyAdded ? isAlreadyAdded :  '100%'};

  > img {
    width: ${({ isImageWidth }) => isImageWidth ? isImageWidth : '60px'};
    height: ${({ isImageWidth }) => isImageWidth ? isImageWidth : '60px'};
  }
  @media (max-width: 500px) {
    display: block;
    float: none;
    margin: 0 auto;
  }
`;


export const InviteButtonWrapper = styled.div`
width:100%;
display:flex;
border: ${({ NoBorder }) => (NoBorder ? "" : "1px solid #005C874D")};
padding:0 25px 0 25px;
.button{
width: ${({ width }) => (width ? "48%" : "100%")};
font-size: ${({ font }) => (font ? font : "18px")};
line-height: 24px;
font-family: Lato;
color: ${({ disabled }) => (disabled ? 'white' : "white")};
padding: 13px 8px 13px 8px;
padding: ${({ padding }) => (padding ? padding : "13px 8px 13px 8px")};
display: flex;
margin-bottom: ${({ margin }) => (margin ? margin : "15px")};
justify-content: center;
border-radius: 3px;
cursor: ${({ cursor }) => (cursor ? "" : "pointer")};
background: ${({ disabled }) =>disabled ? '#005C874D' : "#005C87"};
box-shadow: ${({ disabled }) => (disabled ? '' : "0px 8px 24px 0px #005C8780")};
}



.inviteButton{
  width: ${({ width }) => (width ? "48%" : "200px")};
  font-size: ${({ font }) => (font ? font : "16px")};
  line-height: 20px;
  font-family: 'Lato';
  color: ${({ disabled }) => (disabled ? '#989898' : "white")};
  padding: 12px 16px;
  padding: ${({ padding }) => (padding ? padding : "12px 16px")};
  display: flex;
  align-items: center;
  margin: ${({ margin }) => (margin ? "4px auto 16px auto" : "16px")};
  justify-content: center;
  border-radius: 4px;
  cursor: ${({ cursor }) => (cursor ? "" : "pointer")};
  background: ${({ disabled }) =>disabled ? '#EFEFEF' : "#F37A65"};
}


`;



export const InputWrapper = styled.div`
width:100%;
padding: ${({ inputPadding }) => (inputPadding ? inputPadding : "20px 25px 0px 25px")};

.titleName{
  color:  #184A61;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  margin-bottom: 12px;
}

`;



export const StyledInput = styled.input`
  border: none;
  padding: 0px 20px 0px 20px;
  box-shadow: none;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 0;
  height:${({ isHeight }) => isHeight ? isHeight : '50px'};  
  font-family:${({ isFont }) => isFont ? isFont : 'Lato'};  
  font-weight:400;
  width: 100%;
  border-radius:6px;
  color:${({ color }) => color ? color : 'rgba(0, 47, 71, 1)'};
  border:${({ border }) => border ? border : '1px solid #cdcbcb'};
  background-color:${({ bgColor }) => bgColor ? bgColor : 'rgba(156, 156, 156, .04)'};
  cursor: ${({ disabled }) => disabled && 'not-allowed !important'};

  &:active{
    border:${({ border }) => border ? border : '1px solid #9c9c9c'};
  }
  &::placeholder {
    font-size: 16px;
    color: #BDBDBD;
    color:${({ pColor }) => pColor ? pColor : '#9c9c9c'};
    font-family: Lato;
    font-weight: 400;
    vertical-align: middle;
    line-height: 20px;
  }

  &:focus, &:active {
    outline: none;
  }
  
`;